import React from "react";

import screenfull from "screenfull";

import socketIOClient from "socket.io-client";
import moneyFormat from "@/modules/moneyFormat";

import img_close_popup from "@/assets/img/svg/buttons/close.svg";

import fillRoadmapFilters from "@/modules/fillRoadmapFilters";


// Generic CSS imports
import "@/assets/fonts/sl-fonts/style.css";
import "@/index.scss";
import "@/scrollbars.scss";
import "../../frombootstrap.scss";
import "../../mobile.scss";

import "../MaximizeGameV2/index.scss";
import "../MaximizeGameV2/dark.scss";

import "../MaximizeGameV4/index.scss";
import "../MaximizeGameV4/dark.scss";

import sfx_click from "@/assets/mp3/click.mp3";
import bgm_lobby from "@/assets/mp3/bg_music.mp3";

import { handleTouchDown, handleTouchRelease } from "@/modules/mouseInteractions";

import { assetImg } from "@/modules/moduleImporter";

import {
	isDev,

	PopupResultHistory,
	setActiveGame,

	isPortrait,

	checkFetchStatus,

	fetchGameHistory,
	toggleFullscreen,

	fetchResultHistory,

	initUserdata,
	defaultLogo,
	fillRoadmapText,
	pushGameResultHistory,
	devWarnings,
	tempDataPage,
} from "@/modules/commonMobile";

import {
	// Language Support
	fetchLanguageData,
	updateLanguage,
} from "@/modules/locales";

import {
	getDefaultSocketParameters,

	// Socket emitters
	emitLobbyConnect,
	emitLobbyDisconnect,
	getSocketEndpoint,
} from "@/modules/sockets";

import {
	playBGM,
} from "@/modules/sounds";

import {
	fetchTransactionHistory,
	toggleTransactionDetail,
	changeTransactionPage,

	defaultTransactionHistoryState,
} from "@/modules/transactions"

import {
	changePortraitResultHistoryTab,
	openResultHistory,
	openTransactionHistory
} from "@/modules/commonPopupResultHistory";

import {
	activateGameGroup,
	bindCommonGameGroupingFunctions,
} from "@/modules/gameGrouping";

import {
	setSettingProperties,
	updateSettings,
	defaultSettingsState,
} from "@/modules/settings";


/* Component Imports */

import SettingsForm from "../Settings";

import PopupTransactionHistory from "../PopupTransactionHistory";
import PopupResultHistoryGameList from "../PopupResultHistoryGameList";
import PopupHowToPlay from "../PopupHowToPlay";

// import Preloader from "../Preloader";
/* End of Component Imports */

import LobbyMobileGame from "./LobbyMobileGame";

import { isIPhone } from "@/modules/iOSDetection";
import { IMobileLobbyState as IMobileLobbyState, sharedGameWrapperState } from "@/modules/sharedState";
import { newGetPcode, getBasePcode, getFirstNotEmptyPcode, totoGames, isTotoGroup, getFirstTotoPcode, getAvailableTotoPcodes, getPcodesByCategory, getGroupSize } from "@/modules/gamePcode";
import { toggleHowToPlay, changeHowToPlayPcode, toggleHowToPlayDropdown } from "@/modules/howToPlay";
import { resetLoadingScreen, hideLoadingScreen } from "@/modules/loading";
import { setLobbyRoadmapFilter, toggleFavourite } from "@/modules/onlyLobbyMethods";
import initSocketIO from "./initSocketIO";
import { fetchGameList, fetchGameTime, fetchSoundVolumes, fetchUserData } from "./fetchAPIs";
import { sidebarFragment } from "./sidebarFragment";
import Header from "./Header";

interface IProps {
	match?: any;
}

export default class MobileLobby extends React.Component<IProps, IMobileLobbyState> {
	//TYPE DEFINITIONS
	activePcode: string;

	hasEmittedLobbyConnect = false;

	setLobbyGameFilter: (e: any) => void;
	setLobbyRoadmapFilter = setLobbyRoadmapFilter.bind(this);

	toggleShowGameGroup: (e: any) => void;
	toggleFavourite = toggleFavourite.bind(this);
	toggleFullscreen: () => void;

	// Settings
	protected updateSettings = updateSettings;
	protected updateLanguage = updateLanguage;

	//Lobby Scroll
	handleTouchDown: (e: any) => void;
	handleTouchRelease: (e: any) => void;
	scrollClickTolerance: number;

	//Sounds
	sfxClick: HTMLAudioElement;
	bgmLobby: HTMLAudioElement;
	playBGM: () => void;
	playedBGM: boolean;

	//Fullscreen click handler
	onclick: (e: any) => void;

	socketio: typeof socketIOClient;

	//Timeouts & Intervals
	intervalUserData: number;
	intervalGameTime: number;
	timerTimer: number;
	addedTimers: boolean;
	checkGameGroupInterval: number;

	//Icons
	// sidemenuIcons: any;

	//Orientation
	onOrientationChangeFunction: (e: any) => void;

	fetchGameHistory = fetchGameHistory;
	fetchResultHistory: (e: any) => void;

	//Transaction
	allowRefetchTransaction: boolean;
	fetchTransactionHistory: (e?: any) => void;
	toggleTransactionDetail: (e: any) => void;

	hasHiddenLoadingScreen: boolean;
	//END OF TYPE DEFINITIONS

	constructor(props: IProps) {
		super(props);

		//Touch & move event handlers
		this.handleTouchDown = handleTouchDown.bind(this);
		this.handleTouchRelease = handleTouchRelease.bind(this);
		this.scrollClickTolerance = 30; //in pixels

		bindCommonGameGroupingFunctions(this);

		this.state = {
			...sharedGameWrapperState,

			...defaultSettingsState,
			...defaultTransactionHistoryState,


			showSidebar: false,

			// Top buttons near category selector
			showAllRoadmap: false,
			showAllHistory: false, //true

			//Checks hovered game
			activeHover: "",

			userdata: null,
			lang: null,

			games: null,
			timers: null,
			activeGame: null,
			favouritedGames: [],

			//Orientation event detection
			orientation: isPortrait() ? "portrait" : "landscape", //window.screen.orientation,

			//Mandatory for PopupResultHistory
			portraitTabIndex: 0,

			isFullscreen: false,

			showLobbyGameGroup: false,
			lobbyGameFilter: null,
			activeGameGroup: null,
			showCategories: false,

			uniqueGamePcodes: null,
			gameGroups: null,
			fastTableGames: null,

			//Game Result History
			showGameResultHistoryPopup: false,
			showGameResultHistoryLoadingOverlay: false,
			gameResultHistoryPage: 0,

			//How to Play
			showHowToPlay: false,
			showHowToPlayDropdown: false,
			howToPlayPcode: null,

			showErrorPage: false,
			errorType: null,
			errorMessage: null,

			activeVideoQuality: "sd",
		};

		//start of SocketIO
		const mobileLobby = this;

		// Copied from MaximizeMobileGame
		mobileLobby.toggleFullscreen = toggleFullscreen.bind(this);
		mobileLobby.onclick = function () {
			// console.log("Body click touch");

			if (!screenfull.isFullscreen)
				mobileLobby.toggleFullscreen();
		};

		if (screenfull.enabled)
			screenfull.on("change", () => {
				console.log("Fullscreen?", screenfull.isFullscreen ? "Yes" : "No");

				if (!screenfull.isFullscreen)
					mobileLobby.setState({ isFullscreen: false });
			});

		//SFX & BGM
		this.sfxClick = new Audio(sfx_click);
		this.bgmLobby = new Audio(bgm_lobby);

		this.playBGM = playBGM.bind(this);
		// this.playClickSFX = playClickSFX.bind(this);

		window.addEventListener("touchstart", function () {
			// Check first click to start playing the BGM
			if (!mobileLobby.playedBGM) {
				if (mobileLobby.state.userdata.user.enableMusic) {
					mobileLobby.playBGM();
					mobileLobby.playedBGM = true;
				}
			}
		});

		//to debug window screen sizes
		//console.log("inIframe", inIframe());
		//console.log("wsw wsh", window.screen.width, window.screen.height);
		//console.log("wiW wiH", window.innerWidth, window.innerHeight);

		//COPIED FROM MaximizeMobileGame
		if ("onorientationchange" in window) {
			this.onOrientationChangeFunction = function () {
				mobileLobby.setState({ orientation: isPortrait() ? "portrait" : "landscape" }); //window.screen.orientation });
			};

			window.addEventListener("orientationchange",
				this.onOrientationChangeFunction, false);
		}

		this.initFullscreen();
	}

	private initFullscreen() {
		const self = this;
		this.toggleFullscreen = toggleFullscreen.bind(this);

		document.onclick = function () {
			if (self.allowFullscreen())
				self.toggleFullscreen();
		};
	}

	componentDidMount() {
		devWarnings(this);

		this.fetchGameList({ firstTime: true });
		this.fetchUserData({ firstTime: true });
	}

	componentWillUnmount() {
		this.bgmLobby.pause();
		this.bgmLobby.currentTime = 0;
		delete this.bgmLobby;

		const socket = this.socketio;

		const socketEvents = [
			"loadNewValue",
			"closeTimer",
			"user_recount",
			"reconnect_attempt"
		];

		socketEvents.forEach(eventName => {
			// console.log("cWU eN", eventName);
			socket.off(eventName);
		});

		emitLobbyDisconnect(this, this.state.userdata);

		delete this.socketio;

		resetLoadingScreen();

		//Clears common intervals
		window.clearInterval(this.intervalUserData);
		window.clearInterval(this.intervalGameTime);

		window.removeEventListener("orientationchange", this.onOrientationChangeFunction);
	}

	private allowFullscreen() {
		return (
			this.hasHiddenLoadingScreen &&
			!screenfull.isFullscreen
		);
	}

	checkGameGroup() {
		const mobileLobby = this;

		this.checkGameGroupInterval = window.setInterval(() => {
			if (isDev())
				console.log("polling games for group...", mobileLobby.props);

			if (mobileLobby.state.games && mobileLobby.props.match) {
				window.clearInterval(mobileLobby.checkGameGroupInterval);

				//Activate Baccarat group automatically
				const gameGroupName = mobileLobby.props.match.params.game;
				if (gameGroupName) {
					if (isDev())
						console.log("LM tpmpg", gameGroupName);

					const groupPcode = gameGroupName === "idnlotto"
						? totoGames[0]
						: newGetPcode(gameGroupName);

					mobileLobby.setState({
						activeGameGroup: groupPcode,
						showLobbyGameGroup: true,
						showAllRoadmap: true,
					});
				}
			}
		}, 250);
	}

	// initSocketIO.ts
	protected initSocketIO = initSocketIO;

	// fetchAPIs.ts
	fetchGameList = fetchGameList;
	fetchGameTime = fetchGameTime;
	fetchUserData = fetchUserData;
	fetchSoundVolumes = fetchSoundVolumes;

	allowFetchUserData = true;

	protected closeSidebar() {
		this.setState({ showSidebar: false });
	}

	protected openSidebar() {
		this.setState({ showSidebar: true });
	}

	private toggleAllRoadmap() {
		const { showAllRoadmap } = this.state;

		this.setState({
			showAllHistory: false,
			showAllRoadmap: !showAllRoadmap
		});
	}

	private toggleAllHistory() {
		const { showAllHistory } = this.state;

		this.setState({
			showAllRoadmap: false,
			showAllHistory: !showAllHistory
		});
	}

	private toggleShowCategories() {
		const { showCategories } = this.state;

		this.setState({
			showCategories: !showCategories
		});
	}

	protected decrementGameTimers(self: MobileLobby) {
		if (!self || !self.state.timers)
			return;

		const { timers } = self.state;

		for (const pcode in timers) {
			const timer = timers[pcode];

			if (timer.time > 0)
				timer.time -= 1;
			else timer.time = 0;
		}

		self.setState({ timers });
	}

	private renderCondition() {
		const { userdata, games, activeGame, lang } = this.state;
		return userdata && games && activeGame && lang;
	}

	private loadingMessageFragment() {
		const
			{ games, timers, userdata, lang } = this.state,
			devClass = isDev() ? " dev" : "";

		return (
			<div className={"fullscreen-message" + devClass}>
				{
					!games
						? <div>Loading games...</div>
						: null
				}
				{
					!timers
						? <div>Loading timers...</div>
						: null
				}
				{
					!userdata
						? <div>Loading user data...</div>
						: null
				}
				{
					!lang
						? <div>Loading language data...</div>
						: null
				}
			</div>
		);
	}

	sidebarFragment = sidebarFragment;
	private readonly lobbyCategories = ["fast-tables", "casino", "ball", "dice", "other"];

	/*
	* for use in lobbyGameFragment()
	* setter: fetchAPIs > fetchGameList()
	*/
	categoryCache = null;

	private categoryListFragment() {
		if (!this.state.showCategories)
			return null;

		const
			{ lobbyGameFilter } = this.state,
			categories = this.lobbyCategories;

		return (
			<div className="category-container">
				{
					categories.map((item, idx) => {
						const
							key = `tb${idx}`,
							classList = [
								"tip",
								"tip-all-games",
								(lobbyGameFilter === item ? "active" : "")
							].join(" "),
							{ lang } = this.state;

						return (
							<div
								key={key}
								className={classList}
								{...{ filter: item }}
								onClick={this.setLobbyGameFilter.bind(this)}>

								{assetImg("top_icons", item + "_games.svg")}

								<div>
									{
										lang[`txt_${item}_games`] ||
										`${item.toUpperCase()} GAMES`
									}
								</div>
							</div>
						);
					})
				}
			</div>
		);
	}

	private get showAllGames() {
		return this.state.lobbyGameFilter === "all";
	}

	private topButtonsFragment() {
		const
			{ showAllGames } = this,
			{
				lang, lobbyGameFilter,
				showLobbyGameGroup, showAllHistory,
				showAllRoadmap, showCategories
			} = this.state,
			columnWidthClass = isPortrait() ? "col-xs-3" : "col-125";

		return (
			<div className="top-buttons">
				<div className={columnWidthClass}>
					<div className={
						"tip tip-all-games " +
						(lobbyGameFilter === "favorites" ? "active" : "")
					}
						{...{
							filter: showAllGames ? "favorites" : "all",
							// for this.toggleShowGameGroup
							mobile: "true"
						}}

						onClick={
							showLobbyGameGroup ?
								this.toggleShowGameGroup :
								this.setLobbyGameFilter
						}>

						{
							showLobbyGameGroup || !showAllGames
								? <div>
									{lang["txt_back"]}
								</div>
								: <>
									{assetImg("top_icons", "favorite_games.svg")}
									<div>{lang["txt_favorites"]}</div>
								</>
						}
					</div>
				</div>

				<div className={columnWidthClass}>
					<div className={"tip tip-all-games " + (showAllHistory ? "active" : "")}
						onClick={this.toggleAllHistory.bind(this)}>

						{assetImg("top_icons", "history.svg")}

						<div>
							{lang["txt_history"]}
						</div>
					</div>
				</div>

				<div className={columnWidthClass}>
					<div className={"tip tip-all-games " + (showAllRoadmap ? "active" : "")}
						onClick={this.toggleAllRoadmap.bind(this)}>

						{assetImg("top_icons", "roadmap.svg")}

						<div>
							{lang["txt_roadmap"]}
						</div>
					</div>
				</div>

				<div className={columnWidthClass}>
					<div className={"tip tip-all-games " + (showCategories ? "active" : "")}
						onClick={this.toggleShowCategories.bind(this)}>

						{assetImg("top_icons", "other_games.svg")}

						<div>
							{lang["txt_categories"]}
						</div>
					</div>
				</div>

				{this.categoryListFragment()}
			</div>
		);
	}

	private gameListFragment() {
		const { showLobbyGameGroup, gameGroups } = this.state;

		if (showLobbyGameGroup || !gameGroups)
			return null;

		const
			{
				lobbyGameFilter,
				favouritedGames,
				fastTableGames
			} = this.state;

		// console.log("Filter: ", lobbyGameFilter);

		switch (lobbyGameFilter) {
			case "favorites":
				return this.renderGameList(favouritedGames);
			case "fast-tables":
				return this.renderGameList(fastTableGames);
			default:
				return this.showAllGames
					? this.renderGameList(Object.keys(gameGroups))
					: this.renderGameList(this.categoryCache[lobbyGameFilter]);
		}
	}

	renderGameList(codes: string[]) {
		if (!codes || !codes.length)
			return null;

		const
			{
				lang: langdata,
				gameGroups
			} = this.state;

		// console.log("rGL codes: ", codes);
		// console.log("activeGameGroup: " + this.state.activeGameGroup);

		return (
			codes.map((code, idx) => {
				if (!gameGroups[code])
					return null;

				const pcode = isTotoGroup(code)
					? getFirstTotoPcode(gameGroups[code])
					: gameGroups[code][0];

				return (
					<LobbyMobileGame
						key={"sLGG_" + idx}

						{...{
							ingroup: false,
							pcode,
							langdata,
							...this.state,
							...this
						}}

						activateGameGroup={activateGameGroup.bind(this)}
					/>
				);
			})
		)
	}

	private groupGameListFragment() {
		if (!this.state.showLobbyGameGroup)
			return null;

		const
			{ games, activeGameGroup, lang: langdata } = this.state,
			gamePcodes = Object.keys(games);

		const groupGamePcodes = isTotoGroup(activeGameGroup)
			? getAvailableTotoPcodes(gamePcodes)
			: gamePcodes.filter(pcode =>
				getBasePcode(pcode) === activeGameGroup
			);

		groupGamePcodes.sort();

		return (
			groupGamePcodes.map((pcode, idx) =>
				<LobbyMobileGame
					key={"sLGG_detail_" + idx}

					{...{
						langdata,
						pcode,
						...this.state,
						...this
					}}

					ingroup={true}
					showLobbyGameGroup={true}
				/>
			)
		);
	}

	private gameResultHistoryFragment() {
		const { showGameResultHistoryPopup } = this.state;

		if (!showGameResultHistoryPopup)
			return null;

		const
			{ orientation, lang: langdata } = this.state,
			sameProps = {
				mobileHome: true,
				langdata,
				...this.state
			};

		return (
			<>
				<div className={`game-result-history-popup-overlay ${orientation}`}
					onClick={openResultHistory.bind(this)} />

				<img className={`popup-close-button ${orientation} ${isIPhone() ? " iphone" : ""}`}
					src={img_close_popup}
					alt="close popup"
					onClick={openResultHistory.bind(this)} />

				<PopupResultHistoryGameList
					{...sameProps}
					activeGamePcode={this.state.activeGame.pcode}
					setActiveGame={setActiveGame.bind(this)}
				/>

				<PopupResultHistory
					{...sameProps}
					fetchResultHistory={this.fetchResultHistory.bind(this)}
					changePortraitResultHistoryTab={changePortraitResultHistoryTab.bind(this)}
				/>
			</>
		);
	}

	private transactionHistoryFragment() {
		if (!this.state.showTransactionHistoryPopup)
			return null;

		const
			{
				lang: langdata, orientation, userdata,
				showTransactionHistoryLoadingOverlay
			} = this.state,
			{ currency } = userdata.user;

		return (
			<>
				<div className={`game-result-history-popup-overlay ${orientation}`}
					onClick={openTransactionHistory.bind(this)} />

				<img className={`popup-close-button ${orientation} ${isIPhone() ? " iphone" : ""}`}
					src={img_close_popup}
					alt="close popup"
					onClick={openTransactionHistory.bind(this)} />

				<div className={`side-transaction-history-panel mobile-home ${orientation}`}>
					<PopupTransactionHistory
						{...{
							langdata,
							currency,
							...this.state
						}}

						fetchTransactionHistory={this.fetchTransactionHistory.bind(this)}
						changeTransactionPage={changeTransactionPage.bind(this)}
						toggleTransactionDetail={this.toggleTransactionDetail.bind(this)}
					/>

					{
						showTransactionHistoryLoadingOverlay ?
							<div className="game-transaction-history-overlay">
								Loading...
							</div>
							: null
					}
				</div>
			</>
		);
	}

	private howToPlayFragment() {
		if (!this.state.showHowToPlay)
			return null;

		const
			{ lang: langdata } = this.state;

		return (
			<PopupHowToPlay
				{...{
					mobile: true,
					desktop: false,
					langdata,
					...this.state
				}}

				changeHowToPlayPcode={changeHowToPlayPcode.bind(this)}
				toggleHowToPlay={toggleHowToPlay.bind(this)}
				toggleHowToPlayDropdown={toggleHowToPlayDropdown.bind(this)}
			/>
		);
	}

	render() {
		if (!this.renderCondition())
			return this.loadingMessageFragment();

		if (!this.hasHiddenLoadingScreen) {
			hideLoadingScreen();
			this.hasHiddenLoadingScreen = true;
		}

		const
			wrapperClassList = [
				this.state.showSidebar ? "toggled" : ""
			].join(" "),
			//
			mobileHomeClassList = [
				"mobile-home",
				this.state.orientation,
				(isIPhone() ? "iphone" : "android")
			].join(" ");

		return (
			<div>
				<div id="wrapper" className={wrapperClassList}>
					{this.sidebarFragment()}

					<div className={mobileHomeClassList}>
						<Header
							{...this.state}
							openSidebar={this.openSidebar.bind(this)}
						/>

						<div className="mobile-home-spacer" />

						{this.topButtonsFragment()}

						{this.gameListFragment()}
						{this.groupGameListFragment()}

						{this.gameResultHistoryFragment()}
						{this.transactionHistoryFragment()}
						{this.howToPlayFragment()}
					</div>
				</div>
			</div>
		);
	}

}
